import React from 'react';
import styles from './AlertModalContent.module.css';

interface AlertModalContentProps {
  title: string;
  /** Set by callers inside an EventedModal so the dialog can point aria-labelledby at the
   * title it already renders, instead of repeating the string in an aria-label. */
  titleId?: string;
  subtext?: string;
  icon?: React.ReactNode;
  action: React.ReactNode;
}

export const AlertModalContent: React.FC<AlertModalContentProps> = ({
  title,
  titleId,
  subtext,
  icon,
  action
}) => {
  return (
    <div className={styles.modalContent}>
      <div className={styles.modalHeader}>
        <div className={styles.modalHeading}>
          {icon}
          <h2 id={titleId} className={styles.modalTitle}>
            {title}
          </h2>
        </div>
        {subtext && <p className={styles.modalSubtext}>{subtext}</p>}
      </div>
      {action}
    </div>
  );
};
